var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"face",on:{"click":_vm.takePhoto}},[_c('img',{attrs:{"src":require("./img/sanma.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }